import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';


const useRedirect = () => {
  const navigate = useNavigate();
  const restaurantDetailFailure = useSelector(
    (state: any) => state.restaurant.restaurantDetailsFailure
  );
    const restaurantDetailSuccess = useSelector(
    (state: any) => state.restaurant.restaurantDetailsSuccess
  );
  const restaurantDetailLoading = useSelector(
    (state: any) => state.restaurant.restaurantDetailLoading
  );
  useEffect(() => {
    if (restaurantDetailFailure && !restaurantDetailLoading) {
      
      // navigate("/notFound")
    }
  }, [restaurantDetailFailure])

  return {

  };
};

export default useRedirect;
